import React, { useState } from "react";
import { textCodes } from "../../template_codes/willow/header_codes";

export default function Header() {
    return (

        <div>
            <div class="carousel w-full">
                <div id="item1" class="carousel-item w-full bg-willow_banner3 bg-cover">
                    <ul className="w-full text-center py-4">
                        <li><p className="text-xs lg:text-lg xl:text-lg pb-2 px-2 bg-[#E9E5E2]"></p></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
